import { gql } from "@apollo/client";

const PREVIEW_ALL_FEES = gql`
  query PreviewAllFees($quarter: Int!, $year: Int!) {
    previewAllFees(quarter: $quarter, year: $year) {
      date
      quarter
      year
      dafFees {
        dafName
        advisorName
        firmName
        partnerName
        accountMask
        custodian
        arrearFee
        adminFee
        adminFeeHigh
        quarterBeginningBalance
        quarterEndingBalance
        quarterHighBalance
      }
      productOwner {
        _id
        firstName
        lastName
      }
    }
  }
`;

const RECONCILE_ARREAR_FEES = gql`
  query ReconcileArrearFees($quarter: Int!, $year: Int!, $requestedDate: String!) {
    reconcileArrearFees(quarter: $quarter, year: $year, requestedDate: $requestedDate) {
      quarter
      year
      requestedDate
      rows {
        dafName
        advisorName
        firmName
        partnerName
        productId
        originalArrear
        recalculatedArrear
        arrearDelta
        lateContributionCount
        lateContributionTotal
      }
      productOwner {
        _id
        firstName
        lastName
      }
    }
  }
`;

const FEE_SCHEDULES = gql`
  query FeeSchedules($forProductType: String) {
    feeSchedules(forProductType: $forProductType) {
      _id
      feeName
      isDefault
      forProductType
      billingFrequency
      tiers {
        minAmount
        maxAmount
        feePercentage
      }
      yearlyMinimumFee
      adminFee {
        enabled
        method
        flatAmount
      }
      arrearFee {
        enabled
        method
        tierOffsetSource
        proRate
      }
      flatFee {
        enabled
        amount
        status
        startDate
        nextExecutionDate
        cancellationDate
      }
      createdAt
      updatedAt
    }
  }
`;

const FEE_SCHEDULE = gql`
  query FeeSchedule($id: ID!) {
    feeSchedule(id: $id) {
      _id
      feeName
      isDefault
      forProductType
      billingFrequency
      tiers {
        minAmount
        maxAmount
        feePercentage
      }
      yearlyMinimumFee
      adminFee {
        enabled
        method
        flatAmount
      }
      arrearFee {
        enabled
        method
        tierOffsetSource
        proRate
      }
      flatFee {
        enabled
        amount
        status
        startDate
        nextExecutionDate
        cancellationDate
      }
      createdAt
      updatedAt
    }
  }
`;

const FEE_SCHEDULE_PRODUCT_COUNT = gql`
  query FeeScheduleProductCount($id: ID!) {
    feeScheduleProductCount(id: $id)
  }
`;

const PRODUCTS_BY_FEE_SCHEDULE = gql`
  query ProductsByFeeSchedule($feeScheduleId: ID!) {
    productsByFeeSchedule(feeScheduleId: $feeScheduleId) {
      ... on DafProduct {
        _id
        name
        productType
        ownerId
        entityId
        totals {
          cash
          stock
          alternativeAssets
          crypto
        }
      }
      ... on CommunityFundProduct {
        _id
        name
        productType
        ownerId
        entityId
        totals {
          cash
          stock
          alternativeAssets
          crypto
        }
      }
      ... on ClatProduct {
        _id
        name
        productType
        ownerId
        entityId
        totals {
          cash
          stock
        }
      }
      ... on BrandingProduct {
        _id
        name
        productType
        ownerId
        entityId
      }
    }
  }
`;

export {
  PREVIEW_ALL_FEES,
  RECONCILE_ARREAR_FEES,
  FEE_SCHEDULES,
  FEE_SCHEDULE,
  FEE_SCHEDULE_PRODUCT_COUNT,
  PRODUCTS_BY_FEE_SCHEDULE,
};
